import React, { useEffect } from 'react';
import moment from 'moment';
import {
  useParams,
  NavLink,
} from 'react-router-dom';

import { env, meta } from '~/commons/config';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';
import Html from '~/commons/components/Html.jsx';

const PageAnnouncement = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();

  useEffect(() => {
    req({
      url: `api/site/announcements/${_id}`,
    });
  }, [_id]);

  return (
    <PageHttp res={res}>
      {(doc) => {
        meta.set({ title: doc.title });

        return (
          <div className="container">
            <div className="readable py-4">
              <div className="row">
                <div className="col">
                  <NavLink to="." className="small text-primary">
                    <img
                      src={'assets/img/long-arrow-left.svg'}
                      style={{ width: '38px', height: '9px' }}
                    />
                    &nbsp;
                    返回比賽提示
                  </NavLink>
                </div>
                <div className="col-auto">
                  <p className="small text-muted">
                    發布日期: {moment(doc.publishAt).format('LL')}
                  </p>
                </div>
              </div>
              <h1 className="h2 mt-3 mb-5 text-center">
                {doc.title}
              </h1>
              {doc.coverImg && (
                <div className="mb-5">
                  <img src={doc.coverImg} />
                </div>
              )}
              <Html>{doc.content}</Html>
            </div>
          </div>
        );
      }}
    </PageHttp>
  );
};

export default PageAnnouncement;
